import { Vue } from "@/public/utils/customVue";
import { appVersion } from "@/public/utils/customVue";
let $edApi = Vue.prototype.$edApi;

export default {
    state: {
        vip: 0,
        fuser: 0, // 是否终身会员
        lang: "",
        showUpgrade: false,
        showBuyframe: false,
        showCompare: false,
        showMarket: false,
        createFileTaskFlag: false,
        onUserTask: false,
        runPlatform: "web", // 运行平台
        upgradeTrigger: "",
        libraryName: "",
        upgradeSuffix: "", // 内购页参数，关闭内购页后清除
        pid: 0,
        nalPromoLoaded: false,
        nalPromo_topbar: {},
        nalPromo_center: {},
        nalPromo_rightbottom: {},
        nalPromo_slider: {},
        close_times: 0,
        discount_times: 3,
        showBuyDiscount: false,
        package_times: 5,
        showBuyPackage: false,
        limitBuyModalTimes: false,
        purchaseBubble: "", //vip弹窗 商业化运营气泡
        expireDate: 0,
        vipExpireDate: "",
    },
    mutations: {
        toPublicStatus(state, payload) {
            state[payload.type] = payload.data;
        },
        changeUILang(state, lang) {
            state.lang = lang;
            localStorage.setItem("lang", lang);
        },
        changePurchaseBubble(state, purchaseBubble) {
            state.purchaseBubble = purchaseBubble;
        },
    },
    getters: {
        edLang: (state) => {
            return state.lang;
        },
        showUpgrade: (state) => {
            return state.showUpgrade;
        },
    },
    actions: {
        purchaseSuccess({ commit, dispatch }) {
            //   dispatch("getUserInfo");
            //   dispatch("getSubscription");
            //   commit("toPublicStatus", { type: "market", data: false });
            //购买完成后，刷新页面
            this._vm.$bus.$emit("purchaseSuccess");
        },
        updateVipStatus({ state, commit }, obj) {
            return new Promise((resolve, reject) => {
                let { user_id, token } = obj;
                let status = 0;
                $edApi
                    .getSubscription({ id: user_id, token })
                    .then((expObj) => {
                        if (expObj) {
                            let { now, online_exp: onlineExp } = expObj,
                                curStamp = new Date(now).getTime(),
                                expStamp = new Date(onlineExp).getTime();
                            if (expStamp > curStamp) {
                                status = 1;
                            }
                            if (status == 1) {
                                resolve();
                            } else {
                                reject();
                            }
                            if (now > onlineExp) {
                                let expired = Math.ceil((now - onlineExp) / (60 * 60 * 24 * 1000));
                                commit("toPublicStatus", { type: "expireDate", data: expired });
                            } else {
                                let date = new Date(onlineExp);
                                let expired = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
                                commit("toPublicStatus", { type: "vipExpireDate", data: expired });
                            }
                        } else {
                            reject();
                        }
                        commit("toPublicStatus", { type: "vip", data: status });
                        // 购买后关闭升级窗口
                        state.vip && commit("toPublicStatus", { type: "showUpgrade", data: false });
                    })
                    .catch((err) => {
                        console.log(err);
                        commit("toPublicStatus", { type: "vip", data: status });
                        reject();
                    });
            });
        },
        getNalPromo({ state, getters }, obj) {
            const uInfo = getters.apiParam;
            const { lang, from } = obj;
            return $edApi
                .getNalPromo({
                    user_id: uInfo.id,
                    token: uInfo.token,
                    lang,
                    v: appVersion,
                })
                .then((res) => {
                    state.nalPromo_topbar = {};
                    state.nalPromo_center = {};
                    state.nalPromo_rightbottom = {};
                    state.nalPromo_slider = {};
                    let data = res.data.data;
                    if (data && data.length) {
                        for (let i = 0; i < data.length; i++) {
                            let item = data[i];
                            if (item.position == 1) {
                                // topbar
                                state.nalPromo_topbar = {
                                    w: item.frame_width,
                                    h: item.frame_height,
                                    img: item.picture,
                                    popups: item.popups,
                                };
                            } else if (item.position == 6) {
                                // topbar
                                state.nalPromo_topbar = {
                                    w: item.frame_width,
                                    h: item.frame_height,
                                    img: item.picture,
                                    popups: item.popups,
                                    url: item.url,
                                };
                            } else if (item.position == 8) {
                                // slider
                                state.nalPromo_slider = {
                                    w: item.frame_width,
                                    h: item.frame_height,
                                    img: item.picture,
                                    popups: item.popups,
                                    url: item.url,
                                };
                            } else if (from == "home") {
                                if (item.position == 2) {
                                    state.nalPromo_center = {
                                        w: item.frame_width,
                                        h: item.frame_height,
                                        img: item.picture,
                                        popups: item.popups,
                                        url: item.url,
                                        wait: item.wait,
                                    };
                                } else if (item.position == 3) {
                                    state.nalPromo_rightbottom = {
                                        w: item.frame_width,
                                        h: item.frame_height,
                                        img: item.picture,
                                        popups: item.popups,
                                        url: item.url,
                                        wait: item.wait,
                                        extra: item.extra,
                                    };
                                }
                            } else if (from == "app") {
                                if (item.position == 4) {
                                    state.nalPromo_center = {
                                        w: item.frame_width,
                                        h: item.frame_height,
                                        img: item.picture,
                                        popups: item.popups,
                                        url: item.url,
                                        wait: item.wait,
                                    };
                                } else if (item.position == 5) {
                                    state.nalPromo_rightbottom = {
                                        w: item.frame_width,
                                        h: item.frame_height,
                                        img: item.picture,
                                        popups: item.popups,
                                        url: item.url,
                                        wait: item.wait,
                                    };
                                }
                            }
                        }
                        state.nalPromoLoaded = true;
                    }
                });
        },
        getBuyModalCloseTimes({ state, getters }) {
            const uInfo = getters.apiParam;
            return $edApi
                .getBuyModalCloseTimes(uInfo.id, uInfo.token)
                .then((result) => {
                    if (!result) {
                        state.limitBuyModalTimes = true;
                        return;
                    }
                    state.limitBuyModalTimes = false;
                    state.close_times = result.open_times;
                    state.discount_times = result.content[0].num;
                    state.package_times = result.content[1].num;
                })
                .catch(() => {
                    state.limitBuyModalTimes = true;
                });
        },
        setBuyModalCloseTimes({ getters }) {
            const uInfo = getters.apiParam;
            return $edApi.setBuyModalCloseTimes(uInfo.id, uInfo.token);
        },
    },
};
